import React, { useState } from "react";

import Popover from "@mui/material/Popover";

import Button from '@mui/material/Button';

import { Link } from "react-router-dom";

function FactsHeader() {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
      <div>
        <h3 className="margin-header">
          Facts
          <Button
            id="popover-1"
            className="btn-circle"
            onClick={handleClick}
          >
            ?
          </Button>
        </h3>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div style={{ padding: '16px' }}>
            <h1>Facts</h1>
            <p>
              Facts are a way of grouping quiz questions together. They are a list
              of facts or characteristics that describe the thing in this card. If
              this card were a person, a fact could be 'age', or 'height' or. If
              this were a disease, a fact could be the prognosis. If this were a
              city, the fact could be the population or capital. If the fact is a
              list, like the side-effects of a medication, you can add a list
              using the 'Add List' button above.
              <br />
              <Link to="https://docs.modquiz.com/#facts">Facts</Link>
            </p>
          </div>
        </Popover>
      </div>
    );
}

export default FactsHeader;
